import type { PlannerProject } from "../types";
import { createCompositionLayout, withRoomOf } from "./layout";
import { productModules } from "./productWorkflow";
import { maxDepth, maxHeight } from "./project";

/** Шкаф публикуется целиком — под этим ключом, а не под номером корпуса. */
export const WARDROBE_TARGET = "wardrobe";
export type TargetKind = "wardrobe" | "shelving" | "chest";
export type Target = {id: string; kind: TargetKind; label: string};
const plural = (n: number, one: string, few: string, many: string) =>
  n % 10 === 1 && n % 100 !== 11 ? one : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? few : many;

/** Габарит шкафа для карточки витрины: как в конструкторе, по расстановке у стен. */
export function wardrobePublicationSize(document: PlannerProject) {
  const project = {...document, modules: productModules(document, "wardrobe")};
  // Сохранённая копия может быть в комнате другой ширины: не сбивать текущую.
  const layout = withRoomOf(project, () => createCompositionLayout(project));
  // Корпуса стоят с зазором в 1 мм — на карточке это шум.
  return {width: Math.round(layout.bounds.width * 100) * 10, height: maxHeight(project), depth: maxDepth(project)};
}

export function publicationTargets(document: PlannerProject): Target[] {
  const wardrobe = productModules(document, "wardrobe");
  const cabinets = wardrobe.filter(m => m.type === "single" || m.type === "double" || m.type === "corner45");
  const size = cabinets.length ? wardrobePublicationSize(document) : null;
  const shelves = document.modules.filter(m => m.type === "shelving");
  return [
    ...(size ? [{id: WARDROBE_TARGET, kind: "wardrobe" as const,
      label: `Шкаф целиком · ${wardrobe.length} ${plural(wardrobe.length, "корпус", "корпуса", "корпусов")} · ${size.width} × ${size.height} × ${size.depth} мм`}] : []),
    ...shelves.map((m, i) => ({id: m.id, kind: m.shelvingKind === "chest" ? "chest" as const : "shelving" as const,
      label: `${i + 1}. ${m.shelvingKind === "chest" ? "Комод" : "Стеллаж"} · ${m.width} × ${m.height} × ${m.depth} мм`}))
  ];
}
